import { Link, styled, Typography } from '@mui/material';

export const ListItemContainer = styled('div', { name: 'ListItemContainer' })();

export const ListItemImage = styled('div', { name: 'ListItemImage' })({
	gridArea: 'image',
	'& img': {
		// TODO: remove
		height: 'unset',
		width: 'unset',
	},
});

export const ListItemTitle = styled(Typography, { name: 'ListItemTitle' })({
	gridArea: 'title',
	fontSize: '1rem',
	fontWeight: 'bold',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

export const ListItemTitleLink = styled(Link, { name: 'ListItemTitle' })({
	gridArea: 'title',
	fontSize: '1rem',
	fontWeight: 'bold',
	width: 'fit-content',
	maxWidth: '100%',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});

type ListBoxProps = {
	gridArea?: string;
};

export const ListItemText = styled(Typography, { name: 'ListItemText' })();

export const ListItemBox = styled('div', { name: 'ListItemBox' })<ListBoxProps>(({ gridArea }) => ({
	gridArea,
}));
export const ListItemBoxUpMd = styled(ListItemBox, { name: 'ListItemBoxUpMd' })(({ theme }) => ({
	[theme.breakpoints.down('md')]: { display: 'none' },
}));
export const ListItemBoxUpLg = styled(ListItemBox, { name: 'ListItemBoxUpLg' })(({ theme }) => ({
	[theme.breakpoints.down('lg')]: { display: 'none' },
}));
export const ListItemBoxDnMd = styled(ListItemBox, { name: 'ListItemBoxDnMd' })(({ theme }) => ({
	[theme.breakpoints.up('md')]: { display: 'none' },
}));
export const ListItemBoxDnLg = styled(ListItemBox, { name: 'ListItemBoxDnLg' })(({ theme }) => ({
	[theme.breakpoints.up('lg')]: { display: 'none' },
}));

export const ListItemBoxIcons = styled(ListItemBox, { name: 'ListItemBoxIcons' })(({ theme }) => ({
	gridArea: 'icons',
	display: 'flex',
	gap: theme.spacing(1),
}));
